'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NumeralFormat = function NumeralFormat(props) {
  var value = props.value,
      numericFormat = props.numericFormat,
      format = props.format,
      enabled = props.enabled;


  if (enabled && format) {
    return _react2.default.createElement(
      'div',
      { className: 'pxl-input-number__format' },
      format((0, _numeral2.default)(value).format(numericFormat))
    );
  }
  return null;
};

NumeralFormat.propTypes = {
  enabled: _propTypes2.default.bool,
  format: _propTypes2.default.func,
  numericFormat: _propTypes2.default.string,
  value: _propTypes2.default.any
};

NumeralFormat.defaultProps = {
  enabled: false,
  numericFormat: '0,0'
};

exports.default = NumeralFormat;